<div
  class="w-full max-w-5xl mx-auto flex flex-col gap-4 border border-gray-300 rounded-lg bg-white"
>
  <lib-feature-header
    title="Commission Invoice"
    [isLoading]="store.loading()"
    (closeClick)="goBack()"
  >
    @if (store.invoice()) {
    <lib-commission-invoice-status-badge [status]="store.invoice()!.status" />
    }
  </lib-feature-header>

  @if (store.error()) {
  <div class="px-4">
    <lib-error-alert [error]="store.error()" />
  </div>
  } @if (store.invoice(); as invoice) {
  <div class="flex flex-col gap-0 divide-y divide-gray-100">
    <!-- Invoice Metadata -->
    <div class="px-4 py-4">
      <dl class="grid grid-cols-2 gap-x-6 gap-y-3 sm:grid-cols-3">
        <div>
          <dt class="text-xs text-gray-500">Invoice Number</dt>
          <dd class="mt-0.5 font-mono text-sm font-medium text-gray-900">
            {{ invoice.invoice_number }}
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500">Payee</dt>
          <dd class="mt-0.5 text-sm font-medium text-gray-900">
            {{ invoice.payee_name }}
          </dd>
          <dd class="text-xs text-gray-400">
            {{ titleCase(invoice.payee_type) }}
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500">Payer</dt>
          <dd class="mt-0.5 text-sm font-medium text-gray-900">
            {{ store.payer() }}
          </dd>
        </div>
        @if (invoice.period_start || invoice.period_end) {
        <div>
          <dt class="text-xs text-gray-500">Period</dt>
          <dd class="mt-0.5 text-sm font-medium text-gray-900">
            {{ formatDate(invoice.period_start) }} –
            {{ formatDate(invoice.period_end) }}
          </dd>
        </div>
        } @if (invoice.due_date) {
        <div>
          <dt class="text-xs text-gray-500">Due Date</dt>
          <dd class="mt-0.5 text-sm font-medium text-gray-900">
            {{ formatDate(invoice.due_date) }}
          </dd>
        </div>
        }
        <div>
          <dt class="text-xs text-gray-500">Created</dt>
          <dd class="mt-0.5 text-sm font-medium text-gray-900">
            {{ formatDate(invoice.created_at) }}
          </dd>
        </div>
        @if (invoice.notes) {
        <div class="col-span-2 sm:col-span-3">
          <dt class="text-xs text-gray-500">Notes</dt>
          <dd class="mt-0.5 text-sm text-gray-900">{{ invoice.notes }}</dd>
        </div>
        }
      </dl>
    </div>

    <!-- Financial Summary -->
    <div class="px-4 py-4">
      <p
        class="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-400"
      >
        Financial Summary
      </p>
      <dl class="grid grid-cols-2 gap-x-6 gap-y-3 sm:grid-cols-3">
        <div>
          <dt class="text-xs text-gray-500">Total Amount</dt>
          <dd class="mt-0.5 text-sm font-semibold text-gray-900">
            {{ formatMoney(invoice.total_amount_minor, invoice.currency) }}
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500">Paid Amount</dt>
          <dd class="mt-0.5 text-sm font-semibold text-green-700">
            {{ formatMoney(invoice.paid_amount_minor, invoice.currency) }}
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500">Remaining</dt>
          <dd
            class="mt-0.5 text-sm font-semibold"
            [class]="
              store.remainingAmount() > 0 ? 'text-amber-700' : 'text-gray-900'
            "
          >
            {{ formatMoney(store.remainingAmount(), invoice.currency) }}
          </dd>
        </div>
      </dl>
    </div>

    <lib-commission-invoice-line-items
      [lineItems]="invoice.line_items"
      [currency]="invoice.currency"
    />

    @if (canViewPayments()) {
    <lib-commission-invoice-payment-history
      [payments]="store.payments()"
      [loading]="store.paymentsLoading()"
      [canReversePayment]="canReversePayment()"
      (reversePayment)="onOpenReversePayment($event)"
    />
    }

    <!-- Action Buttons -->
    <div class="px-4 py-4">
      <div class="flex flex-wrap gap-3 justify-end">
        @if (canAddPayment()) {
        <button
          type="button"
          class="inline-flex items-center rounded-md bg-green-600 px-4 py-2 text-sm font-semibold text-white hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
          (click)="onOpenAddPayment()"
        >
          Record Payment
        </button>
        } @if (canApprove()) {
        <button
          type="button"
          class="inline-flex items-center rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          (click)="onApprove()"
          [disabled]="store.loading()"
        >
          Approve
        </button>
        } @if (canCancel()) {
        <button
          type="button"
          class="inline-flex items-center rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          (click)="onCancel()"
          [disabled]="store.loading()"
        >
          Cancel Invoice
        </button>
        }

        <shared-cancel-button text="Close" (cancelled)="goBack()" />
      </div>
    </div>
  </div>
  }
</div>

<lib-add-payment-modal
  [invoiceId]="invoiceId ?? ''"
  [currency]="store.invoice()?.currency ?? 'KES'"
  [remainingAmount]="store.remainingAmount()"
  (paymentSubmit)="onAddPayment($event)"
/>

<lib-reverse-payment-modal (reverseSubmit)="onReversePayment($event)" />
